export let accessOptions = [
  { label: "Select Access", value: "" },
  { label: "No Access", value: "No Access" },
  { label: "Admin", value: "Admin" },
  { label: "Manager", value: "Manager" },
  { label: "Accountant", value: "Accountant" },
];

export const default_access = [
  {
    module: "Main Dashboard",
    access: "No Access",
    id: "dashboard",
  },
  {
    module: "Client and Projects",
    access: "No Access",
    id: "default",
  },
  {
    module: "Vendor",
    access: "No Access",
    id: "default",
  },
  {
    module: "Organization Profile",
    access: "No Access",
    id: "default",
  },
  {
    module: "Organization Bank",
    access: "No Access",
    id: "default",
  },
  {
    module: "Tax Deducted at Source (TDS)",
    access: "No Access",
    id: "tax",
  },
  {
    module: "Direct Tax",
    access: "No Access",
    id: "tax",
  },
  {
    module: "Goods and Services Tax (GST)",
    access: "No Access",
    id: "tax",
  },
  {
    module: "Users",
    access: "No Access",
    id: "default",
  },
  {
    module: "Purchase Items",
    access: "No Access",
    id: "items",
  },
  {
    module: "Sales Items",
    access: "No Access",
    id: "items",
  },
  {
    module: "Invoice GST",
    access: "No Access",
    id: "invoices",
  },
  {
    module: "Invoice TDS",
    access: "No Access",
    id: "invoices",
  },
  {
    module: "Payment Received",
    access: "No Access",
    id: "invoices",
  },
  // {
  //   "module": "Legacy List",
  //   "access": "No Access"
  //   "id":"default"
  // },
];
